import React from "react";
import {Form} from "react-bootstrap";
import {addDays, isCalendarDate, monthDay, signOffBody} from "./rsoForecastWindowHelpers";

// How far back "Date you told Purchasing" may go. The forecasting service checks it against its own Denver today.
export const SIGN_OFF_DAYS_BACK = 31;
// A new sign-off for an override: told Purchasing today (the input week's Denver date), with no note yet.
export const newSignOff = (today) => ({toldPurchasingOn: isCalendarDate(today) ? today : "", note: ""});

// The sign-off Sales records before sending an override: when they told Purchasing and what they agreed.
// Used in the property's review and in the No units confirmation. NANCY adds who signed and when it was sent.
// caseLine: what this send is (a first answer or a change, see overrideCaseLine).
// today: the input week's Denver date; disabled: a send whose outcome is unknown is retried with this exact sign-off.
export default function RsoOverrideSignOff({idPrefix, caseLine, today, value, onChange, disabled = false}) {
  const max = isCalendarDate(today) ? today : undefined;
  const min = max ? addDays(max, -SIGN_OFF_DAYS_BACK) : undefined;
  const {toldPurchasingOn, note} = signOffBody(value);
  const dateOutside = isCalendarDate(toldPurchasingOn) && !!max && (toldPurchasingOn > max || toldPurchasingOn < min);
  const change = (field) => (event) => onChange?.({...value, [field]: event.target.value});
  return <fieldset className="rpf-override-signoff">
    <legend>Override sign-off</legend>
    {caseLine && <p className="rpf-override-case">{caseLine}</p>}
    <Form.Group controlId={`${idPrefix}-told`} className="mb-2">
      <Form.Label>Date you told Purchasing</Form.Label>
      <Form.Control type="date" required value={value?.toldPurchasingOn || ""} min={min} max={max} disabled={disabled}
        isInvalid={!disabled && (!isCalendarDate(toldPurchasingOn) || dateOutside)} onChange={change("toldPurchasingOn")} />
      <Form.Control.Feedback type="invalid">{max ? `Choose a date from ${monthDay(min)} to ${monthDay(max)}.` : "Choose the date you told Purchasing."}</Form.Control.Feedback>
    </Form.Group>
    <Form.Group controlId={`${idPrefix}-note`} className="mb-2">
      <Form.Label>Note (what you agreed)</Form.Label>
      <Form.Control as="textarea" rows={2} required maxLength={2000} value={value?.note || ""} disabled={disabled}
        placeholder="Who you spoke to and what you agreed." onChange={change("note")} />
      {!disabled && !note && <Form.Text>Required.</Form.Text>}
    </Form.Group>
  </fieldset>;
}
